import { FallbackError } from "@core/domain/errors/fallback.error";
import { GraphDatasource } from "@station/data/datasources/graph.datasource.ts";
import type { GraphFilters } from "@station/domain/models/graph.model.ts";
import { Graph } from "@station/domain/models/graph.model.ts";
import type { GraphRepository } from "@station/domain/repositories/graph.repository.ts";
import { inject, injectable } from "inversify";
import type { ResultAsync } from "neverthrow";

@injectable()
export class GraphImplRepository implements GraphRepository {
    constructor(
        @inject(GraphDatasource)
        private readonly graphDatasource: GraphDatasource,
    ) {}

    getAll(): ResultAsync<Graph[], FallbackError> {
        return this.graphDatasource.fetchAll();
    }

    fetchById(filter: GraphFilters): ResultAsync<Graph[], FallbackError> {
        return this.graphDatasource.fetchById(filter);
    }
}
